export type CompanySection = 'greeting' | 'vision' | 'history' | 'certification' | 'partners' | 'location';

// 회사소개 하위 메뉴 (Header 메뉴와 순서 동일)
export const COMPANY_MENU: { section: CompanySection; label: string; to: string; desc: string }[] = [
  {
    section: 'greeting',
    label: '인사말',
    to: '/company/greeting',
    desc: '가치 있는 아이디어를 완성도 높은 결과물로 만드는 G-WORKS의 인사말입니다.',
  },
  {
    section: 'vision',
    label: '미션 · 비전',
    to: '/company/vision',
    desc: 'G-WORKS가 지향하는 미션과 비전, 회사 플랫폼을 소개합니다.',
  },
  {
    section: 'history',
    label: '연혁',
    to: '/company/history',
    desc: 'G-WORKS가 걸어온 길과 대표이사의 주요 이력을 소개합니다.',
  },
  {
    section: 'certification',
    label: '인증',
    to: '/company/certification',
    desc: 'G-WORKS가 보유한 사회적기업 인증 등 공식 인증 현황입니다.',
  },
  {
    section: 'partners',
    label: '협력사',
    to: '/company/partners',
    desc: 'G-WORKS와 함께하는 협력사를 소개합니다.',
  },
  {
    section: 'location',
    label: '오시는 길',
    to: '/company/location',
    desc: '방문 상담은 사전 예약 후 이용해주세요. 자체 공장과 디자인 스튜디오가 함께 있습니다.',
  },
];
